module.exports = __webpack_public_path__ + "img/2522934.png";